import { SKILLS } from "../data/portfolio";
import { Reveal } from "./Reveal";

export const Skills = () => {
  const all = SKILLS.flatMap((g) => g.items);
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="relative border-t border-white/10 py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between gap-6 mb-16">
          <Reveal>
            <p className="label-eyebrow">02 / Capabilities</p>
            <h2 className="mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-tight">
              Tools of the trade.
            </h2>
          </Reveal>
          <Reveal delay={150} className="hidden sm:block">
            <p className="text-sm text-white/50 max-w-sm text-right">
              From training neural networks to wiring up React front-ends and
              shipping APIs on AWS.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border border-white/10">
          {SKILLS.map((group, gi) => (
            <Reveal
              key={group.label}
              delay={gi * 100}
              className="p-6 border-b lg:border-b border-white/10 md:border-r border-r-0 lg:border-r"
              data-testid={`skill-group-${group.label.toLowerCase().replace(/[^a-z]/g, "")}`}
            >
              <p className="label-eyebrow text-white">{group.label}</p>
              <ul className="mt-6 space-y-2">
                {group.items.map((it) => (
                  <li
                    key={it}
                    className="font-mono-ui text-sm text-white/80 flex items-center gap-3"
                  >
                    <span className="w-1 h-1 bg-white/50 inline-block" />
                    {it}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Marquee */}
      <div
        className="mt-20 border-y border-white/10 py-6 overflow-hidden"
        data-testid="skills-marquee"
      >
        <div className="marquee-track flex gap-12 whitespace-nowrap font-display font-black text-3xl sm:text-5xl tracking-tighter text-white/15 uppercase">
          {[...all, ...all].map((s, i) => (
            <span key={i} className="flex items-center gap-12">
              {s}
              <span className="text-white/10">/</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
